import { FormCrudDataGrid, FormCrudDataGridProps } from "src/components/common/dataGrid/crud/FormCrudDataGrid";
import { AsyncState } from "src/utils/async/asyncState";
import { AsyncRender } from "src/components/common/async/AsyncRender.tsx";

export interface ControlledAsyncFormCrudDataGridProps<RowData extends object>
	extends Omit<FormCrudDataGridProps<RowData>, "rows" | "loading"> {
	rowsAsync: AsyncState<RowData[]>;
}

export const ControlledAsyncFormCrudDataGrid = <RowData extends object>({
	rowsAsync,
	refreshData,
	...other
}: ControlledAsyncFormCrudDataGridProps<RowData>) => {
	return (
		<AsyncRender
			asyncData={rowsAsync}
			reloadOnError={refreshData}
			content={(rows) => <FormCrudDataGrid rows={rows} refreshData={refreshData} {...other} />}
		/>
	);
};
